import React from 'react';
import { Form, Field } from 'react-final-form';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '../forms/TextField';
import Timer from './Timer';

const textStyle = { color: '#28558a', fontWeight: 600, margin: '0 0 12px' };

// Challenge response form shared by the ID and QR login boxes (HIA-BUG-20260929-4).
// The challenge VALUE is never shown nor stored by the front: it reaches the user on the channel of
// their account (HIA app, SMS or e-mail). Only a generic instruction and the countdown are displayed.
const ChallengeResponseForm = ({ loginInformation, attemptError, onSubmit, onExpire }) => {
    const submit = (values, form) => {
        onSubmit((values.response || '').trim());
        setTimeout(() => form.reset(), 0);
    };
    return (
        <Form
            onSubmit={submit}
            render={({ handleSubmit, pristine, invalid }) => (
                <form onSubmit={handleSubmit} className="challengeResponseForm">
                    <Grid container justify="center" style={{ marginBottom: 20 }}>
                        <Timer key={loginInformation.challengeId} duration={loginInformation.timer} onExpire={onExpire} />
                    </Grid>
                    <div style={{ padding: '0 24px' }}>
                        <p className="challengeInstruction" style={textStyle}>
                            Un code vous a été transmis — application HIA, SMS ou e-mail selon votre compte.
                            Décodez-le avec votre formule secrète puis saisissez la réponse.
                        </p>
                        <Field
                            component={TextField}
                            id="challengeResponse"
                            name="response"
                            type="text"
                            label="Réponse"
                            autoComplete="off"
                            autoFocus
                            margin="dense"
                            variant="outlined"
                            fullWidth
                        />
                        {attemptError && (
                            <p className="challengeAttemptError" role="alert" style={{ color: 'red', margin: '8px 0' }}>
                                {attemptError.message}
                            </p>
                        )}
                    </div>
                    <Grid container justify="center" style={{ margin: '12px 0' }}>
                        <Button type="submit" color="primary" disabled={pristine || invalid}>
                            OK
                        </Button>
                    </Grid>
                    <p style={{ padding: '0 24px', fontSize: 13 }}>
                        En cas de difficulté, contactez-nous : contact@hiasecure.com
                    </p>
                </form>
            )}
        />
    );
};

export default ChallengeResponseForm;
